/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_REGISTER, API_LOGIN, API_LOGOUT, API_LOGOUT_GUEST } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../style/general/node.entry.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/


const Screen = ({loading, error, location}) => {

    let STORAGE_USER = reactLocalStorage.get('@guest_user');

    const [name, set_name] = useState('');

    const [username, set_username] = useState('');

    const [password, set_password] = useState('');

    const [password_look, set_password_look] = useState(false);

    const [handle_register, set_handle_register] = useState(false);

    const [refresh, set_refresh] = useState(false);

	//#region redux ------------------------------------------------

	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}

	//#endregion redux ---------------------------------------------

    const _login = () => {

		loading(true);

		API_REGISTER('auth/guest__________', {
            action: 'login',
			username: username,
			password: password
		})
        .then((response) => {
			if(response.data.result === 'success'){
                reactLocalStorage.set('@token', response.data.data);
                reactLocalStorage.set('@guest_user', JSON.stringify(response.data.user));
                _set_redux_user(JSON.stringify(response.data.user))
                window.location.reload();
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _register = () => {

        loading(true);

		API_REGISTER('auth/guest__________', {
            action: 'register',
            name: name,
			username: username,
			password: password
		})
        .then((response) => {
			if(response.data.result === 'success'){
                error('Berhasil Mendaftar, Silahkan Masuk');
                set_name('')
                set_username('')
                set_password('');
                set_handle_register(false)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }

    const _logout = () => {

        loading(true);

		API_LOGOUT_GUEST('auth/guest/logout__________')
        .then((response) => {
			if(response.data.result === 'success'){
                reactLocalStorage.clear();
                _set_redux_user('')
                set_refresh(false)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
        })
        
    }
    
    useEffect(() => {

        if(STORAGE_USER === undefined){
            _set_redux_user('')
        }else{
            _set_redux_user(JSON.parse(STORAGE_USER))
        }

    }, [refresh])

    return (
        <>
            <Helmet>

                <meta name="description" content={'Guest'}/>
                <title>{'Guest'}</title>

            </Helmet>

            <div className="_container">
                <div className="__section_pages_title">
                    <div className="_row _center_align _lily_pad_h_d">
                        <div className="_column">
                            <h1>Guest</h1>
                        </div>
                        {
                            STORAGE_USER &&
                            <div>
                                <a className="_btn" onClick={() => _logout()} style={{cursor: "pointer"}}>
                                    Keluar
                                </a>
                            </div>
                        }
                    </div>
                    <div className="_lily_pad_h_d">
                        {
                            !STORAGE_USER &&
                            <>
                                <br/>
                                <a className="_btn _push_r_m" onClick={() => set_handle_register(false)} style={{cursor: "pointer", color: handle_register ? '#555' : '#000'}}>
                                    Masuk
                                </a>
                                <a className="_btn" onClick={() => set_handle_register(true)} style={{cursor: "pointer", color: !handle_register ? '#555' : '#000'}}>
                                    Daftar
                                </a>
                            </>
                        }
                    </div>
                </div>
                {
                    !STORAGE_USER ?

                        !handle_register ?
                        <div className="_row_auto">
                            <div className="_column_auto">
                                <div className="_row">
                                    <div className="_push_r_m">
                                        <ion-icon style={{fontSize: 18}} name="person-outline"></ion-icon>
                                    </div>
                                    <div className="_column">
                                        <input
                                            className="__input" 
                                            placeholder={'Username'} 
                                            onChange={e => set_username(e.target.value)}
                                            value={username}
                                        />
                                    </div>
                                </div>
                                <br/>

                                <div className="_row">
                                    <div className="_push_r_m">
                                        <ion-icon style={{fontSize: 18}} name="lock-closed-outline"></ion-icon>
                                    </div>
                                    <div className="_column">
                                        <input
                                            className="__input"
                                            type={password_look ? 'Text' : 'password'} 
                                            placeholder={'Password'} 
                                            onChange={e => set_password(e.target.value)}
                                            value={password}
                                        />
                                    </div>
                                    <div className="_push_l_m" onClick={() => {
                                        if(password_look){
                                            set_password_look(false)
                                        }else{
                                            set_password_look(true)
                                        }
                                    }} style={{cursor: 'pointer'}}>
                                        {
                                            password_look ?
                                                <ion-icon style={{fontSize: 18}} name="lock-open-outline"></ion-icon>
                                            :
                                                <ion-icon style={{fontSize: 18}} name="lock-closed-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                                <br/>
                                <a className="_btn" onClick={() => _login()} style={{cursor: "pointer"}}>
                                    Masuk
                                </a>
                            </div>
                            <div className="_column_auto_2"/>
                        </div>

                        :

                        <div className="_row_auto">
                            <div className="_column_auto">
                                <div className="_row">
                                    <div className="_push_r_m">
                                        <ion-icon style={{fontSize: 18}} name="text-outline"></ion-icon>
                                    </div>
                                    <div className="_column">
                                        <input
                                            className="__input" 
                                            placeholder={'Nama'} 
                                            onChange={e => set_name(e.target.value)}
                                            value={name}
                                        />
                                    </div>
                                </div>
                                
                                <br/>
                                <div className="_row">
                                    <div className="_push_r_m">
                                        <ion-icon style={{fontSize: 18}} name="person-outline"></ion-icon>
                                    </div>
                                    <div className="_column">
                                        <input
                                            className="__input" 
                                            placeholder={'Username'} 
                                            onChange={e => set_username(e.target.value)}
                                            value={username}
                                        />
                                    </div>
                                </div>
                                <br/>

                                <div className="_row">
                                    <div className="_push_r_m">
                                        <ion-icon style={{fontSize: 18}} name="lock-closed-outline"></ion-icon>
                                    </div>
                                    <div className="_column">
                                        <input
                                            className="__input"
                                            type={password_look ? 'Text' : 'password'} 
                                            placeholder={'Password'} 
                                            onChange={e => set_password(e.target.value)}
                                            value={password}
                                        />
                                    </div>
                                    <div className="_push_l_m" onClick={() => {
                                        if(password_look){
                                            set_password_look(false)
                                        }else{
                                            set_password_look(true)
                                        }
                                    }} style={{cursor: 'pointer'}}>
                                        {
                                            password_look ?
                                                <ion-icon style={{fontSize: 18}} name="lock-open-outline"></ion-icon>
                                            :
                                                <ion-icon style={{fontSize: 18}} name="lock-closed-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                                <br/>
                                <a className="_btn" onClick={() => _register()} style={{cursor: "pointer"}}>
                                    Daftar
                                </a>
                            </div>
                            <div className="_column_auto_2"/>
                        </div>

                    :
                        <div className="_lily_pad_h_d" style={{maxWidth: 500}}>
                            {
                                redux_user.data&&
                                <h3 className="_push_b_s">{redux_user.data[0].name}</h3>
                            }
                            <p>Selamat sekarang kamu sudah login sebagai tamu. Semua fitur yang membutuhkan hak akses, sekarang dapat kamu gunakan.</p>
                        </div>
                }
            </div>
        </>
    );

}

export default Screen;